import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface ExternalRedirectButtonProps {
  href: string;
  label: string;
  className?: string;
  newTab?: boolean;
}

export function ExternalRedirectButton({
  href,
  label,
  className,
  newTab = false,
}: ExternalRedirectButtonProps) {
  return (
    <Button
      className={cn('py-5 text-data-card-xs font-bold text-white bg-mr-teal-dark', className)}
      onClick={(e) => {
        e.stopPropagation();
        if (newTab) {
          window.open(href, '_blank', 'noopener,noreferrer');
        } else {
          window.location.assign(href);
        }
      }}
    >
      {label}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <path d="M15 3h6v6" />
        <path d="M10 14 21 3" />
        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
      </svg>
    </Button>
  );
}
